import React from 'react';

export const AuditReadinessIcon: React.FC = () => (
  <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M50 100C77.6142 100 100 77.6143 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6143 22.3858 100 50 100Z" fill="#2A4CA4"/>
    <path d="M50 20L74 30V54C74 67 63 77 50 82C37 77 26 67 26 54V30L50 20Z" fill="white"/>
    <path d="M37 51L45 60L63 41" stroke="#2A4CA4" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
